import { render } from "./LeadsPage.vue?vue&type=template&id=39ab1f3a&scoped=true"
import script from "./LeadsPage.vue?vue&type=script&lang=js"
export * from "./LeadsPage.vue?vue&type=script&lang=js"

import "./LeadsPage.vue?vue&type=style&index=0&id=39ab1f3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ab1f3a"]])

export default __exports__